<template>
  <el-date-picker
    :editable="editable"
    :clearable="clearable"
    class="date-picker"
    @change="change"
    :style="`width: ${width}`"
    :picker-options="pickerOptions"
    v-model="tempData"
    :type="dateType"
    :value-format="valueFormat"
    default-time="23:59:59"
    placeholder="选择日期">
  </el-date-picker>
</template>

<script>
  export default {
    name: "DatePicker",
    model: {
      event: 'change',
    },
    props: {
      value: String,
      type: String,
      width: {
        type: String,
        default: "100%",
      },
      shortcuts: Array,
      dateType: {
        type: String,
        default: "date",
      },
      format: {
        type: String,
        default: "",
      },
      clearable: {
        type: Boolean,
        default: false
      },
      editable: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        tempData: this.value,
        pickerOptions: {},
        valueFormat: "",
      }
    },
    watch: {
      value(val) {
        this.tempData = val;
      }
    },
    methods: {
      getValueFormat(type) {
        switch (type) {
          case "date": return "yyyy-MM-dd";
          case "datetime": return "yyyy-MM-dd HH:mm:ss";
          case "month": return "yyyyMM";
        }
      },
      getDisabledDate(type) {
        switch (type) {
          case "after": return time => time.getTime() < Date.now() - 8.64e7;
          case "before": return time => time.getTime() > Date.now();
          default: return () => {};
        }
      },
      change(val) {
        this.$emit("change", val || "");
      },
    },
    created() {
      this.pickerOptions.disabledDate = this.getDisabledDate(this.type);
      this.pickerOptions.shortcuts = this.shortcuts;
      this.valueFormat = this.format || this.getValueFormat(this.dateType);
    }
  }
</script>

<style lang="scss">
  .date-picker {
    input {
      cursor: pointer;
    }
  }
</style>
